import React from 'react';
import { ExclamationTriangleIcon } from '@heroicons/react/24/outline';
import { format, parseISO } from 'date-fns';
import { Task } from '../api/tasks';
import { BrandModal, BrandModalBody, BrandModalFooter, BrandModalHeader } from './ui/BrandModal';

interface DeleteTaskModalProps {
  isOpen: boolean;
  onClose: () => void;
  onConfirm: () => void;
  task: Task | null;
}

export default function DeleteTaskModal({ isOpen, onClose, onConfirm, task }: DeleteTaskModalProps) {
  if (!task) return null;

  return (
    <BrandModal open={isOpen} onClose={onClose} maxWidthClass="max-w-md">
      <BrandModalHeader title="Delete Task" onClose={onClose} />
      <BrandModalBody>
        <div className="flex gap-3">
          <div className="flex h-10 w-10 shrink-0 items-center justify-center rounded-full bg-rose-100">
            <ExclamationTriangleIcon className="h-6 w-6 text-rose-600" />
          </div>
          <div className="text-left text-sm text-slate-600">
            <p>
              Are you sure you want to delete <strong className="text-slate-900">{task.title}</strong>?
            </p>
            {task.dueDate ? (
              <p className="mt-2 text-slate-500">Due: {format(parseISO(task.dueDate), 'MMM d, yyyy')}</p>
            ) : null}
            <p className="mt-2 text-rose-600">This action cannot be undone.</p>
          </div>
        </div>
      </BrandModalBody>
      <BrandModalFooter>
        <button type="button" onClick={onClose} className="btn btn-secondary focus-pop">
          Cancel
        </button>
        <button type="button" onClick={onConfirm} className="btn btn-danger focus-pop">
          Delete Task
        </button>
      </BrandModalFooter>
    </BrandModal>
  );
}
